import { LogoIcon } from '@lichtblick/icons/svg/logo/logo';
import classNames from 'classnames';

import styles from './logo.module.scss';

export const Logo = () => <LogoIcon className={classNames('logo', styles.logo)} />;
